<template>
  <p :id="props.id" class="modern-color-theme font-poppins" :class="theme.text" data-component-name="VSDescription">
    <slot />
  </p>
</template>
<script setup lang="ts">
import type { ThemeProp } from '@component-library/themes';
import { useTheme } from './VSDescription.theme';

const props = defineProps<{
  id?: string
  theme?: ThemeProp<typeof useTheme>
}>()

const theme = useTheme(props)

defineOptions({
  name: 'VSDescription'
})
</script>